export const errorMessagesCopy = code => {

  switch (code) {
    case 503:
      return `LANDMARKS Intelligence Platform is currently unavailable due to scheduled maintenance.
      We will let you know when it is back online.
      In the meantime, just relax, be kind to yourself, you deserve it.`;
    default:
        return `Something has gone wrong and the team have been notified.
        Please can you try again, as it could have been a glitch in the Matrix.`;
  }

}
